import { Link } from 'react-router-dom';
import React from 'react';

export const EventLogLink = ({ item, overrideCollectionLink = null }) => {
  const useCollection = overrideCollectionLink || item.collection;

  if (useCollection) {
    return <Link to={`/${useCollection}/${item.id}`}>{item.value}</Link>;
  }
  return EventLogText({ item });
};

export const EventLogText = ({ item }) => {
  return item.value ? item.value : 'Error';
};
